import { DateTime } from 'luxon';
import { Datatype } from '../../../../datatype/Datatype.ts';
import { createConditionOperator } from '../../IConditionOperator.ts';

const MONTH_OPTIONS = [
  { value: 1, label: 'Gennaio' },
  { value: 2, label: 'Febbraio' },
  { value: 3, label: 'Marzo' },
  { value: 4, label: 'Aprile' },
  { value: 5, label: 'Maggio' },
  { value: 6, label: 'Giugno' },
  { value: 7, label: 'Luglio' },
  { value: 8, label: 'Agosto' },
  { value: 9, label: 'Settembre' },
  { value: 10, label: 'Ottobre' },
  { value: 11, label: 'Novembre' },
  { value: 12, label: 'Dicembre' },
];

const DATE_FORMATS = [
  'yyyy-MM-dd',
  'dd/MM/yyyy',
  'MM/dd/yyyy',
  "yyyy-MM-dd'T'HH:mm:ss",
];

function parseMonthFromDate(value: any): number | null {
  const dateString = String(value);

  // Gestisce stringhe ISO (anche con offset/Z), es. 2025-11-30T10:00:00Z
  const dateIso = DateTime.fromISO(dateString);
  if (dateIso.isValid) return dateIso.month;

  for (const format of DATE_FORMATS) {
    const date = DateTime.fromFormat(dateString, format);
    if (date.isValid) return date.month;
  }

  return null;
}

export const ConditionOperatorMonthBetweenType = createConditionOperator({
  code: 'monthBetween',
  label: 'mese compreso tra',
  description: 'Mese compreso tra due valori',
  args: [
    {
      type: 'staticValue',
      field: {
        type: Datatype.Number,
        label: 'Da mese',
        options: MONTH_OPTIONS,
      },
    },
    {
      type: 'staticValue',
      field: { type: Datatype.Number, label: 'A mese', options: MONTH_OPTIONS },
    },
  ] as const,
  allowsField: field => field.type === Datatype.Date,
  compare(value: any, [startMonth, endMonth]: [number, number]) {
    if (value == null || startMonth == null || endMonth == null) return false;

    const start = Number(startMonth);
    const end = Number(endMonth);

    // Se start o end non sono numeri interi validi tra 1 e 12, restituisce false
    if (!(Number.isInteger(start) && Number.isInteger(end))) return false;
    if (start < 1 || start > 12 || end < 1 || end > 12) return false;

    const month = parseMonthFromDate(value);
    if (month == null) return false;

    // Gestione wrap-around (es. Novembre→Febbraio attraversa il cambio anno)
    if (start <= end) {
      return month >= start && month <= end;
    }
    return month >= start || month <= end;
  },
});
